import { render, staticRenderFns } from "./SettingsView.vue?vue&type=template&id=6f035521&"
import script from "./SettingsView.vue?vue&type=script&lang=js&"
export * from "./SettingsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports